"use client";

import { X } from "lucide-react";

type BackendSaveMessagePropsT = {
  message: {
    type: "success" | "error";
    message: string;
  } | null;
  onDismiss?: () => void;
};

export function BackendSaveMessage({
  message,
  onDismiss,
}: BackendSaveMessagePropsT) {
  if (!message) return null;

  return (
    <div
      className={`flex items-center justify-between px-10 py-3 text-sm ${
        message.type === "success"
          ? "border-b border-green-200 bg-green-50 text-green-700"
          : "border-b border-red-200 bg-red-50 text-red-700"
      }`}
    >
      <span>{message.message}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="ml-3 cursor-pointer transition-opacity hover:opacity-70"
          aria-label="Nachricht schließen"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
